<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->

<template>
	<div class="WordSection1">
		<p
			class="MsoNormal"
			align="center"
			style="margin-bottom:7.5pt;text-align:center;
line-height:normal"
		>
			<b
				><span
					lang="FR-CA"
					style='font-size:11.5pt;font-family:
"Lato",sans-serif;color:#333333'
					>Entente de l'utilisateur final</span
				></b
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p
			class="MsoNormal"
			align="center"
			style="margin-bottom:7.5pt;text-align:center;
line-height:normal"
		>
			<b
				><span
					lang="FR-CA"
					style='font-size:11.5pt;font-family:
"Lato",sans-serif;color:#262626'
					>Responsabilités de l'utilisateur</span
				></b
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Cette entente est conclue entre Croix Bleue Medavie (« Croix Bleue ») et l'utilisateur (« vous » ou « votre ») des
				portails Web, des applications Web, des interfaces, des outils et des systèmes mis à la disposition de l'utilisateur
				par Croix Bleue, par l'entremise de son site Web (appelées collectivement et individuellement le « site »).</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Si vous êtes un utilisateur des sections sécurisées Administrateurs de régimes collectifs ou Professionnels de la
				santé du présent site Web, « Croix Bleue » désigne l'organisation qui offre le régime de garanties ou la police
				d'assurance dont vous êtes l'administrateur ou dont votre client est l'adhérent. Plus précisément, « Croix Bleue »
				fait référence à Croix Bleue Medavie ou à Croix Bleue de la Saskatchewan.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Lorsque vous accédez au site de Croix Bleue ou que vous l'utilisez, vous acceptez les conditions suivantes :</span
			>
		</p>

		<ul type="disc">
			<li class="MsoNormal" style="color:#262626;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'
					>L'Énoncé de protection des renseignements personnels de Croix Bleue (accessible aux adresses suivantes
					:&nbsp;</span
				><span style="color:#black"
					><a
						href="#"
						@click="
							trackTabs('https://www.medaviebc.ca/fr/mentions-legales/renseignements-personnels', 'PRIVACY')
						"
						><span
							lang="FR-CA"
							style='font-size:11.5pt;font-family:"Arial",sans-serif;
     color:#0078A7'
							>https://www.medaviebc.ca/fr/mentions-legales/renseignements-personnels</span
						></a
					></span
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;et&nbsp;</span
				><span style="color:black"
					><a href="#" @click="trackTabs('http://www.sk.bluecross.ca/privacy/', 'PRIVACYSK')"
						><span
							lang="FR-CA"
							style='font-size:11.5pt;font-family:"Arial",sans-serif;
     color:#0078A7'
							>http://www.sk.bluecross.ca/privacy/</span
						></a
					></span
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;)</span>
			</li>
		</ul>

		<p
			class="MsoNormal"
			style="margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:36.0pt;line-height:normal"
		>
			<span
				style='font-size:11.5pt;
font-family:"Lato",sans-serif;color:#262626'
				>et</span
			>
		</p>

		<ul type="disc">
			<li class="MsoNormal" style="color:#262626;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'
					>L'Avis juridique du site Web de Croix Bleue (accessible aux adresses suivantes :&nbsp;</span
				><span style="color:#262626"
					><a href="#" @click="trackTabs('https://www.medaviebc.ca/fr/mentions-legales', 'LEGAL')"
						><span
							lang="FR-CA"
							style='font-size:11.5pt;font-family:"Arial",sans-serif;
     color:#0078A7'
							>https://www.medaviebc.ca/fr/mentions-legales</span
						></a
					></span
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'>&nbsp;et&nbsp;</span
				><span style="color:#262626"
					><a href="#" @click="trackTabs('http://www.sk.bluecross.ca/legal/', 'LEGALSK')"
						><span
							lang="FR-CA"
							style='font-size:11.5pt;font-family:"Arial",sans-serif;
     color:#0078A7'
							>http://www.sk.bluecross.ca/legal/</span
						></a
					></span
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif'>&nbsp;)</span>
			</li>
		</ul>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Ces conditions, ainsi que l'ensemble des énoncés de confidentialité, des avis juridiques, des polices et des ententes
				applicables mentionnés dans les présentes conditions, constituent l'entente conclue entre vous et Croix Bleue.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Croix Bleue peut modifier le site ou la présente entente, y compris l'Énoncé de protection des renseignements
				personnels, l'Avis juridique et les ententes applicables mentionnés aux présentes, avec votre consentement ou non.
				Croix Bleue vous avisera de toute modification aux présentes conditions dès vous accéderez au site ou que vous
				l'utiliserez. Si vous continuez d'accéder à ce site ou de l'utiliser après l'entrée en vigueur desdites modifications,
				nous considérerons que vous avez accepté les modifications.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
					>1. Obligations en matière de confidentialité, de respect de la vie privée et de sécurité</span
				></b
			><span
				lang="FR-CA"
				style='font-size:11.5pt;font-family:"Lato",sans-serif;
color:#262626'
				><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(1) Les renseignements, les documents et le contenu accessibles dans les pages du présent site Web, ainsi que tout
				autre renseignement obtenu auprès de Croix Bleue ou communiqué à celle-ci par l'intermédiaire du site, notamment les
				détails au sujet d'une personne identifiable, les renseignements médicaux, les renseignements financiers ou tout autre
				renseignement permettant d'identifier une personne, un groupe ou un programme, sont strictement confidentiels (appelés
				collectivement les « renseignements »).</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(2) Vous préserverez la confidentialité des renseignements, et les protégerez contre la perte ou le vol, ainsi que
				contre tout accès ou toute divulgation, reproduction, utilisation ou modification non autorisés.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(3) Vous vous assurerez que tous les renseignements transmis ou modifiés à l'aide du présent site sont exacts,
				complets et opportuns.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(4) Vous protégerez tous les renseignements. Il s'agit notamment de conserver les renseignements dans un endroit
				sécurisé, d'utiliser des mots de passe pour protéger les fichiers, de protéger les renseignements transmis par voie
				électronique ou communiqués par téléphone, notamment les renseignements envoyés par courrier électronique.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(5) Vous assurerez la confidentialité de vos nom d'utilisateur et mot de passe personnels et vous ne les divulguerez
				à quiconque ni à aucune entité. Vous acceptez d'être tenu(e) responsable de toute utilisation de vos nom d'utilisateur
				et mot de passe personnels, y compris une utilisation non autorisée sans votre consentement, et vous reconnaissez que
				Croix Bleue n'est tenue de confirmer l'identité d'aucun utilisateur.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(6) Vous ne communiquerez, ne divulguerez ou ne révélerez aucun renseignement obtenu en accédant au site ou en
				utilisant celui-ci sans le consentement de la personne à qui se rapportent les renseignements.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(7) Vous aviserez rapidement Croix Bleue de toute plainte ou de tout conflit concernant les renseignements.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(8) Vous rapporterez immédiatement toute violation de la confidentialité à Croix Bleue.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(9) Si votre relation avec Croix Bleue change et que l'accès au site ou son utilisation n'est plus requis dans
				l'accomplissement de vos tâches, votre droit d'y accéder ou de l'utiliser sera immédiatement révoqué ou prendra fin.
				Au moment de la révocation, vous cesserez immédiatement d'accéder au site ou de l'utiliser.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
					>2. Consentement à recueillir et à utiliser des données sur l'utilisation</span
				></b
			><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>Afin que l'utilisation du site soit, pour vous et les autres utilisateurs, une expérience utile, Croix Bleue
				recueillera certains renseignements sur votre utilisation de ce site. À cette fin, vous autorisez Croix Bleue à
				recueillir et à utiliser des données techniques – notamment, votre adresse IP, votre système d'exploitation et votre
				navigateur – afin d'améliorer votre expérience et celle des autres utilisateurs et de faciliter la prestation du
				soutien technique et d'autres services (s'il y a lieu) liés au site. Croix Bleue peut utiliser ces renseignements aux
				fins décrites dans le présent paragraphe et à d'autres fins connexes, à condition de le faire d'une manière qui permet
				d'éviter toute identification personnelle.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<b
				><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
					>3. Obligations additionnelles découlant de votre relation avec Croix Bleue</span
				></b
			><span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(1) Si vous êtes un utilisateur de la section sécurisée Administrateurs de régimes collectifs de ce site, vous
				acceptez aussi ce qui suit :</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Votre accès au site ou votre utilisation de celui-ci est également assujetti aux conditions de tout régime de
					garanties ou de toute police d'assurance qui lie votre employeur ou votre client à Croix Bleue.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous accéderez aux renseignements contenus sur le site, les utiliserez, les copierez et les modifierez
					uniquement aux fins de l'administration du régime de garanties ou de la police d'assurance et de l'exécution
					des obligations et des fonctions décrites aux présentes.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Si une autre personne a besoin d'accéder au site, vous veillerez à ce qu'elle obtienne son propre code
					d'utilisateur et son propre mot de passe.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous conserverez tous les documents et les formulaires originaux exigés par Croix Bleue.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(2) Si vous êtes un utilisateur de la section sécurisée Professionnels de la santé de ce site, vous acceptez aussi ce
				qui suit :</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<br />
			</span>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Pour l'application de la présente section, si vous utilisez le Service de soumission électronique des
					demandes de règlement de Croix Bleue (le « Service ») pour soumettre des factures en ligne, les conditions
					incluent :</span
				>
			</li>
			<ul type="circle">
				<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
					<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
						>l'entente concernant la soumission électronique des demandes de règlement de Croix Bleue (qui figure
						dans la section sur les professionnels de la santé du site).</span
					>
				</li>
			</ul>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Si votre accès au système ou votre statut de fournisseur approuvé est suspendu ou prend fin, ou si l'entente
					de soumission électronique des demandes de règlement conclue entre vous et Croix Bleue prend fin, votre droit
					d'accéder au site et de l'utiliser sera immédiatement révoqué. Au moment de la révocation, vous cesserez
					immédiatement d'accéder au site ou de l'utiliser.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#0d0d0d'
				><br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#0d0d0d'
				>(3) Si vous êtes un utilisateur de la section de l'application Web sécurisée du Programme de contrôle des ordonnances
				de la Nouvelle-Écosse de ce site, vous acceptez aussi ce qui suit :</span
			>
		</p>

		<ol start="1" type="a">
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous vous engagez à respecter les clauses des politiques et procédures du Programme de contrôle des
					ordonnances de la Nouvelle-Écosse.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous comprenez que les renseignements personnels sur la santé auxquels vous avez accès au moyen de
					l'application Web sécurisée du Programme de contrôle des ordonnances de la Nouvelle-Écosse sont confidentiels
					et que vous ne pouvez pas en discuter avec une personne n'ayant pas reçu l'autorisation d'accéder aux
					renseignements, sauf dans les cas correspondant aux politiques et aux procédures du Programme.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous n'aurez pas recours ou accès aux renseignements personnels sur la santé, sauf lorsqu'ils sont
					nécessaires dans l'exercice de vos fonctions et/ou lorsque le Programme l'autorise.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous rapporterez immédiatement toute violation de la confidentialité au Programme.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif'
					>Vous comprenez que vous êtes responsable d'assurer la sécurité des renseignements auxquels vous avez accès
					conformément aux politiques et aux procédures du Programme en ce qui a trait à la sécurité de
					l'information.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous comprenez que si vous avez des questions ou des préoccupations quant à l'accès, à la divulgation ou à
					l'utilisation des renseignements personnels, vous devez les soulever auprès du Programme.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Si vous deviez, par inadvertance, contrevenir aux dispositions du Programme quant à l'accès, à la divulgation
					ou à l'utilisation des renseignements personnels sur la santé, si vous deviez causer un bris de sécurité
					menant à la divulgation inappropriée de renseignements du Programme, ou si vous allez causer l'accès aux
					renseignements du Programme par des personnes non autorisées, vous comprenez que le Programme inscrira cette
					violation de la confidentialité à votre dossier et que vous pourrez devoir suivre une formation supplémentaire
					sur la confidentialité et la sécurité.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Si vous deviez volontairement contrevenir aux dispositions du Programme quant à l'accès, à la divulgation ou
					à l'utilisation des renseignements personnels sur la santé, si vous deviez causer un bris de sécurité menant à
					la divulgation inappropriée de renseignements du Programme, ou si vous allez causer l'accès aux renseignements
					du Programme par des personnes non autorisées, vous comprenez que votre accès pourrait être révoqué et que
					vous pourrez faire l'objet de mesures disciplinaires de la part de l'autorité vous ayant remis votre
					permis.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>Vous acceptez d'assurer l'entière confidentialité de votre mot de passe. Vous ne communiquerez pas votre mot
					de passe à quiconque. Si vous soupçonnez qu'une autre personne connaît votre mot de passe, vous devez
					immédiatement aviser le Programme.</span
				>
			</li>
			<li class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal;background:white">
				<span lang="FR-CA" style='font-size:11.5pt;font-family:"Arial",sans-serif;color:#0d0d0d'
					>S'il existe un conflit entre toute disposition de cette sous-section 3(3) et toutes autres dispositions de
					cette entente, la disposition pertinente de cette sous-section 3(3) s'appliquera.</span
				>
			</li>
		</ol>

		<p class="MsoNormal" style="margin-bottom:0cm;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				><br />
				<b>4. Généralités</b><br />
				<br />
				<br />
			</span>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(1) Le défaut de respecter toute condition du présent contrat peut entraîner la révocation immédiate de vos droits
				d'accès au site, sans limiter tout autre recours en droit ou en équité que Croix Bleue peut exercer en vue d'une
				application plus poussée du présent contrat.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(2) Le présent contrat sera régi par les lois qui s'appliquent dans la province ou le territoire du Canada qui régit
				le régime de garanties ou la police d'assurance qui vous lie à Croix Bleue. En l'absence d'un tel régime ou d'une
				telle police, ou si vous avez plusieurs régimes ou polices relevant de provinces ou de territoires différents, le
				présent contrat sera régi par les lois qui s'appliquent au Nouveau–Brunswick. Vous vous soumettez irrévocablement à la
				compétence des tribunaux pertinents de cette province. Les parties renoncent par les présentes au droit de procès
				devant jury.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>(3) Vous acceptez que chacune des conditions du présent contrat est essentielle. Si une ou plusieurs des dispositions
				du présent contrat sont déclarées invalides, illégales ou inexécutoires à quelque égard que ce soit, la validité, la
				légalité et la force exécutoire des autres dispositions du présent contrat n'en seront nullement touchées ou
				diminuées, à condition que cela n'ait pas d'incidence négative appréciable, pour toute partie, sur la substance
				commerciale, économique et légale des transactions prévues aux présentes. Advenant une telle déclaration, les parties
				modifieront le présent contrat afin d'en respecter l'intention initiale de la manière la plus fidèle et la plus
				acceptable possible et de veiller à ce que les transactions prévues aux présentes puissent, dans la mesure du
				possible, être exécutées ainsi qu'il a été initialement prévu.</span
			>
		</p>

		<p class="MsoNormal" style="margin-bottom:7.5pt;line-height:normal">
			<span lang="FR-CA" style='font-size:11.5pt;font-family:"Lato",sans-serif;color:#262626'
				>En accédant au site Web ou en l'utilisant, vous déclarez avoir lu la présente entente et avoir compris vos
				obligations et vos responsabilités.</span
			>
		</p>

		<div tabindex="0" />
	</div>
</template>
<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';
import TabTrackerMixin from '@/mixins/tabs';

@Component({
	name: 'UserAgreementFr',
	mixins: [IdMixin, TabTrackerMixin]
})
export default class UserAgreementFr extends Vue {}
</script>
<style lang="scss" @scoped>
/* Font Definitions */
@font-face {
	font-family: Wingdings;
	panose-1: 5 0 0 0 0 0 0 0 0 0;
}
@font-face {
	font-family: 'Cambria Math';
	panose-1: 2 4 5 3 5 4 6 3 2 4;
}
@font-face {
	font-family: Calibri;
	panose-1: 2 15 5 2 2 2 4 3 2 4;
}
@font-face {
	font-family: 'Josefin Sans';
}
@font-face {
	font-family: Lato;
}
/* Style Definitions */
p.MsoNormal,
li.MsoNormal,
div.MsoNormal {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 8pt;
	margin-left: 0cm;
	line-height: 107%;
	font-size: 11pt;
	font-family: 'Calibri', sans-serif;
}
.MsoChpDefault {
	font-family: 'Calibri', sans-serif;
}
.MsoPapDefault {
	margin-bottom: 8pt;
	line-height: 107%;
}
@page WordSection1 {
	size: 612pt 792pt;
	margin: 72pt 72pt 72pt 72pt;
}
div.WordSection1 {
	page: WordSection1;
}
/* List Definitions */
ol {
	margin-bottom: 0cm;
}
ul {
	margin-bottom: 0cm;
}
</style>
